import { Component } from '@angular/core';

@Component({
  selector: 'stars-lesson-anatomy',
  templateUrl: './lesson-anatomy.component.html',
  styleUrls: ['../../pages/lessons.scss']
})
export class LessonAnatomyComponent {
  scrollToSection(sectionId: string): void {
    const section = document.getElementById(sectionId);
    const sectionPosition = section.offsetTop;
    const offsetPosition = sectionPosition - 150;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
}
